var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        staticClass: "pagination-view",
        class: { "pagination-view-disabled": _vm.disabled },
      },
      _vm.$listeners
    ),
    [
      _c(
        "IconComponent",
        {
          staticClass: "pagination-view-arrow pagination-view-arrow-backwards",
          class: { hidden: _vm.isFirstPage },
          on: { click: _vm.onPreviousPageClick },
        },
        [_vm._v("pagination_backwards")]
      ),
      _c(
        "span",
        {
          staticClass: "pagination-view-page-info",
          class: _vm.pageInfoClasses("cover_front"),
        },
        [_vm._v(_vm._s(_vm.$t("cover_front")))]
      ),
      _c(
        "span",
        {
          staticClass: "pagination-view-page-info",
          class: _vm.pageInfoClasses("coverInside"),
        },
        [_vm._v(_vm._s(_vm.$t("coverInside")))]
      ),
      _c(
        "span",
        {
          staticClass: "pagination-view-page-info",
          class: _vm.pageInfoClasses("cover_back"),
        },
        [_vm._v(_vm._s(_vm.$t("cover_back")))]
      ),
      _c(
        "span",
        {
          staticClass: "pagination-view-page-info",
          class: _vm.pageInfoClasses("pageNumber"),
        },
        [_vm._v(_vm._s(_vm.selectedPageNumber) + "/" + _vm._s(_vm.totalPages))]
      ),
      _c(
        "IconComponent",
        {
          staticClass: "pagination-view-arrow pagination-view-arrow-forward",
          class: { hidden: _vm.isLastPage || _vm.pageList.length < 2 },
          on: { click: _vm.onNextPageClick },
        },
        [_vm._v("pagination_forward")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }